import { render } from "./Header.vue?vue&type=template&id=30b5d440"
const script = {}

import exportComponent from "C:\\Users\\User\\Desktop\\SavaJava-Vue\\savajava-global-stocks-dividend-data-and-analysis-toolkit\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__